export default __webpack_public_path__ + "static/WorkSans-Bold-192ded64f49caf3707c3ba8ac470125b.woff2";